module.exports = __webpack_public_path__ + "static/icon-erweima.e45a0ccf.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/icon-erweima.png
// module id = 972
// module chunks = 2